export default [
    {
        name: 'app.dashboard',
        link: '/dashboard',
        icon: 'fa fa-tachometer',
    },
    {
        name: 'app.organisations',
        link: '/admin/organisations',
        icon: 'fa fa-building',
        permission: 'update-organisations',
    },
    {
        name: 'app.relations',
        link: '/admin/relations',
        icon: 'fa fa-users',
        id: 'relations_menu',
        permission: 'view-relations',
        exclusion: 'my-profile'
    },
    {
        name: 'app.trajectory_projects',
        link: '/admin/projects',
        icon: 'fa fa-paperclip',
        permission: 'update-trajectory-projects',
    },
    {
        name: 'app.action_documents',
        link: '/admin/action-documents',
        icon: 'fa fa-puzzle-piece',
        permission: 'update-action-documents',
    },
    {
        name: 'app.invoices',
        link: '/admin/invoices',
        icon: 'fa fa-file',
        permission: 'index-buy-invoices',
    },
    {
        name: 'app.management_info',
        link: '/admin/reports',
        icon: 'fa fa-line-chart',
        permission: 'index-reports',
    },
    {
        name: 'app.faq',
        link: '/admin/faq',
        icon: 'fa fa-question',
        permission: 'index-faq',
    },
    {
        name: 'app.feedback',
        link: '/admin/feedback',
        icon: 'fa fa-commenting',
        permission: 'index-feedback',
    },
    {
        name: 'app.my_profile',
        link: '/admin/relations/my-profile',
        icon: 'fa fa-user-circle',
        permission: 'view-relations'
    },
    {
        name: 'app.settings',
        link: '/admin/settings',
        icon: 'fa fa-cogs',
        permission: 'update-settings',
    },
];
